<template>
  <div class="orderDetails">
    <navigator title="订单详情" :routePath='"/personal/propertyList"'></navigator>
    <!-- 支付剩余时间 -->
    <div class="payCloseTime" v-if="(orderType === 9 || orderType === 13 || orderType === 12) && orderStatus === 5 && payCloseTime">
      <p class="time">支付剩余：{{ time }}</p>
      <p class="timeText">逾期支付，订单将自动取消</p>
    </div>
    <div class="headerTitle">订单信息</div>
    <div class="orderBox">
      <p class="orderTitle">{{DetailsInfo.title}}</p>
      <p class="orderStatus">预计金额：{{DetailsInfo.orderFee / 100 | PriceFilter}} 元</p>
      <p class="orderPrice">核准金额：{{DetailsInfo.approvalFee / 100 | PriceFilter}} 元</p>
      <p class="orderStatus">{{DetailsInfo.orderStatus | orderStatusFilter(DetailsInfo.orderType) }}</p>
      <div class="orderDetalis">
        <p class="orderId">订单编号：{{DetailsInfo.orderId}}</p>
        <p class="orderTime">下单时间：{{DetailsInfo.createTime | DateFilter('yyyy-MM-dd hh:mm:ss')}}</p>
      </div>
      <div class="payInfo">
        <p class="payAmount" v-if="DetailsInfo.payFee">支付金额：{{ DetailsInfo.payFee / 100 | PriceFilter }} 元</p>
        <p class="payAmount"  v-else>支付金额：—— </p>
        <p class="payWay">支付方式：{{ DetailsInfo.payType | payTypeFilter }}</p>
        <p class="payId">支付单号：{{ DetailsInfo.payLogId ? DetailsInfo.payLogId : '——' }}</p>
        <p class="payTime" v-if="DetailsInfo.payTime">支付时间：{{ DetailsInfo.payTime | DateFilter('yyyy-MM-dd hh:mm:ss') }}</p>
        <p class="payTime" v-else>支付时间：—— </p>
      </div>
    </div>
    <div class="headerTitle">订单详情</div>
    <div class="orderDetalis">
      <!-- 绑定信息 -->
      <LinkServiceInfo :linkServiceInfo="DetailsInfo.linkServiceInfo" :linkServiceType="DetailsInfo.linkServiceType"></LinkServiceInfo>

      <!-- 自定义 -->
      <CustomDemo v-if="orderType === 3 || orderType === 10 || orderType === 16 || orderType === 19" :info="orderDetails"></CustomDemo>
      <!-- 美食街 -->
      <FoodDemo v-else-if="orderType === 9" :info="orderDetails"></FoodDemo>
      <!-- 优选服务 -->
      <RecomDemo v-else-if="orderType === 11" :info="orderDetails"></RecomDemo>
      <!-- 产品路演 -->
      <ProductionDemo v-else-if="orderType === 7" :info="orderDetails"></ProductionDemo>
      <!-- 园区活动 -->
      <ParkActivityDemo v-else-if="orderType === 13" :info="orderDetails"></ParkActivityDemo>
      <!-- 专享活动 -->
      <ExclusiveDemo v-else-if="orderType === 14" :info="orderDetails"></ExclusiveDemo>
      <!-- 找工作 -->
      <JobDemo v-else-if="orderType === 4" :info="orderDetails"></JobDemo>
      <!-- 服务外包 -->
      <ServiceDemo v-else-if="orderType === 5" :info="orderDetails"></ServiceDemo>
      <!-- 招培训 -->
      <EduDemo v-else-if="orderType === 6" :info="orderDetails"></EduDemo>
      <!-- 求购 -->
      <NeedBuyDemo v-else-if="orderType === 8" :info="orderDetails"></NeedBuyDemo>
      <!-- 会议室 -->
      <OfficeDemo v-else-if="orderType === 12" :info="orderDetails"></OfficeDemo>
      <!-- 商城 -->
      <ProductDetalisDemo v-else-if="orderType === 17" :info="orderDetails"></ProductDetalisDemo>
      <!--物业报修-->
      <MaintainDemo v-if="orderType === 18" :info="orderDetails"></MaintainDemo>

      <div class="remark" v-if="DetailsInfo.remark">
        <div class="remarkTitle">附言</div>
        <p class="remarkText">{{DetailsInfo.remark}}</p>
      </div>
    </div>

    <div class="headerTitle">个人信息</div>
    <div class="userInfo">
      <p><span class="lable">联系人</span>{{DetailsInfo.applyName}}</p>
      <p><span class="lable">联系电话</span>{{DetailsInfo.applyPhone}}</p>
      <p><span class="lable">职位</span>{{DetailsInfo.applyPosition}}</p>
      <p><span class="lable">公司名称</span>{{DetailsInfo.applyCorpName}}</p>
    </div>

    <div class="headerTitle" v-if="invoiceInfo">发票信息</div>
    <div class="userInfo" v-if="invoiceInfo">
      <van-row class="invoice-row">
        <van-col span="8">发票类型</van-col>
        <van-col span="15" offset="1">{{invoiceInfo.invoiceType == 1 ? '普通发票' : '增值税发票'}}</van-col>
      </van-row>
      <van-row class="invoice-row">
        <van-col span="8">发票抬头</van-col>
        <van-col span="15" offset="1">{{invoiceInfo.invoiceTitle}}</van-col>
      </van-row>
      <van-row class="invoice-row" v-if="invoiceInfo.invoiceType == 2 || invoiceInfo.type==1">
        <van-col span="8">纳税人识别号</van-col>
        <van-col span="15" offset="1">{{invoiceInfo.creditCode}}</van-col>
      </van-row>
      <van-row class="invoice-row" v-if="invoiceInfo.invoiceType == 2">
        <van-col span="8">注册地址</van-col>
        <van-col span="15" offset="1">{{invoiceInfo.registerAddress}}</van-col>
      </van-row>
      <van-row class="invoice-row" v-if="invoiceInfo.invoiceType == 2">
        <van-col span="8">注册电话</van-col>
        <van-col span="15" offset="1">{{invoiceInfo.registerTel}}</van-col>
      </van-row>
      <van-row class="invoice-row" v-if="invoiceInfo.invoiceType == 2">
        <van-col span="8">开户银行</van-col>
        <van-col span="15" offset="1">{{invoiceInfo.bankName}}</van-col>
      </van-row>
      <van-row class="invoice-row" v-if="invoiceInfo.invoiceType == 2">
        <van-col span="8">银行账号</van-col>
        <van-col span="15" offset="1">{{invoiceInfo.bankAccount}}</van-col>
      </van-row>
      <van-row class="invoice-row">
        <van-col span="8">收票人手机</van-col>
        <van-col span="15" offset="1">{{invoiceInfo.receiverMobile}}</van-col>
      </van-row>
    </div>

    <div class="headerTitle" v-if="processList.length>0">订单流程</div>
    <div class="orderBox" v-if="processList.length>0">
      <div class="processInfo" v-for="(item, index) in processList" :key="index">
        <img class="operateStatus" v-if="item.operateStatus==1" src="@/static/image/icon_sptg.png" alt="审批通过">
        <img class="operateStatus" v-else-if="item.operateStatus==2" src="@/static/image/icon_spjj.png" alt="审批拒绝">
        <p class="operateStep">步骤：{{ index+1 }}</p>
        <p class="operateDesc">说明：{{ item.description }}</p>
        <p class="operateUser">处理人：{{ item.userName }}</p>
        <p class="operateTime" v-if="item.operateStatus">处理时间：{{ item.operateTime | DateFilter('yyyy-MM-dd hh:mm:ss') }}</p>
        <p class="operateTime" v-else>处理时间：—— </p>
        <p class="operateRemark" v-if="item.operateStatus">意见：{{ item.remark }}</p>
        <p class="operateRemark" v-else>意见：—— </p>
      </div>
    </div>

    <div class="headerTitle" v-if="orderDetails.orderOperateList">订单操作记录</div>
    <div class="orderBox" v-if="orderDetails.orderOperateList">
      <van-steps direction="vertical" :active="orderDetails.orderOperateList.length-1" active-color="#d9262c">
          <van-step v-for="item in orderDetails.orderOperateList" :key="item.operateId">
              <img class="user-icon" :src="item.userIcon">
              <p class="op-item">{{item.realName ? item.realName : item.userNick}}  {{item.title}}</p>
              <p class="op-item">{{item.createTime | DateFilter('yyyy-MM-dd hh:mm:ss')}}</p>
              <p>{{item.remark}}</p>
          </van-step>
      </van-steps>
    </div>

    <div class="headerTitle" v-if="showEvaluate && orderType!=9">我的评价</div>
    <div class="orderBox" v-if="showEvaluate && orderType!=9">
      <van-rate v-model="DetailsInfo.servicesScore" color="#ed5c00" :readonly="true" />
      <p>{{DetailsInfo.servicesScore | scoreFilter}}</p>
    </div>

    <div class="payFoot">
      <van-button size="normal" type="default" class="btn" v-if="!showEvaluate" :disabled="cancleBtn" @click="orderCancle">取消订单</van-button>
      <van-button size="normal" type="danger" class="btn" v-if="!showEvaluate" :disabled="payBtn" @click="orderPay">去支付</van-button>
      <van-button size="normal" type="danger" class="btn" v-if="showEvaluate" :disabled="evaluateBtn" @click="goEvaluate">去评价</van-button>
    </div>

    <OrderEvaluate v-if="showEvaluate" :showPopup="showPopup" @close="goEvaluate" :orderInfo="DetailsInfo"></OrderEvaluate>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
import LinkServiceInfo from './orderComponents/LinkServiceInfo';
import CustomDemo from './orderComponents/CustomDemo';
import FoodDemo from './orderComponents/FoodDemo';
import RecomDemo from './orderComponents/RecomDemo';
import ProductionDemo from './orderComponents/ProductionDemo';
import ParkActivityDemo from './orderComponents/ParkActivityDemo';
import ExclusiveDemo from './orderComponents/ExclusiveDemo';
import JobDemo from './orderComponents/JobDemo';
import ServiceDemo from './orderComponents/ServiceDemo';
import EduDemo from './orderComponents/EduDemo';
import NeedBuyDemo from './orderComponents/NeedBuyDemo';
import OfficeDemo from './orderComponents/OfficeDemo';
import ProductDetalisDemo from './orderComponents/ProductDetalisDemo';
import MaintainDemo from './orderComponents/MaintainDemo';
import { Popup } from 'vant';
import OrderEvaluate from '../../components/OrderEvaluate';

export default {
  data() {
    return{
      url: '', // 动态url
      cancleBtn: true, // 取消按钮的禁用
      payBtn: true, // 支付按钮的禁用
      showEvaluate: false,//显示评价按钮
      evaluateBtn: true,//评价按钮
      showPopup: false,//评价弹出层
      // 订单信息
      orderId: 0,
      orderType: 0,
      orderStatus: -1,
      DetailsInfo:{},
      // 用户信息
      userinfo: {
        name: '',
        position: '',
        phone: '',
        corp: '',
      },
      //发票信息
      invoiceInfo:null,
      //订单流程信息
      processList: [],
      // 订单详情(传到子组件)
      orderDetails: {},
      //支付时间
      payCloseTime: 0, // 支付关闭时间
      startTime: new Date(), // 今天
      timeInterval: null,
    }
  },
  methods: {
    ...mapMutations(['change_currentParkId']),
    // 获取详情
    getdetails() {
      this.$http.post(`${this.URL_PREFIX}${this.url}`, {
        orderId: this.$route.query.orderId,
      },{
        headers: { token: this.token },
      }).then((res) => {
        if(res.data.resCode === '10000') {
          this.DetailsInfo = res.data.resData;
          this.change_currentParkId(this.DetailsInfo.orderParkId);
          this.orderStatus = res.data.resData.orderStatus;
          this.orderType = res.data.resData.orderType;
          if(res.data.resData.invoiceInfo){
            this.invoiceInfo = JSON.parse(res.data.resData.invoiceInfo);
          }
          //检查订单状态
          if(this.orderStatus === 6) {
            this.showEvaluate = true;
            this.evaluateBtn = this.DetailsInfo.servicesScore>0 ? true : false;
          }
          if(this.orderStatus === 5) {
            this.payBtn = false;
            if(this.orderType === 18){
              this.cancleBtn = true;
            }
          }else{
            this.payBtn = true;
          }
          if(this.orderStatus === 0 || this.orderStatus === 3 || this.orderStatus === 4 || this.orderStatus === 7 || this.orderStatus === 8) {
            this.cancleBtn = true;// 把取消按钮禁用
          }
          //检查订单类型
          if(this.orderType === 3 || this.orderType === 10 || this.orderType === 16) {
            this.processList = res.data.resData.orderServiceInfo.processList; // 订单流程
          }
          if(this.orderType === 9 || this.orderType === 12) {
            this.orderDetails = res.data.resData; // 订单信息
          } else{
            this.orderDetails = res.data.resData.orderServiceInfo ? res.data.resData.orderServiceInfo : {}; // 订单服务信息
          }
          if((this.orderType === 9 || this.orderType === 12 || this.orderType === 13) && this.orderStatus === 5){
            this.payCloseTime = res.data.resData.payCloseTime; // 支付关闭时间
            this.timeInterval = setInterval(() => {
              this.payCloseTime -= 1000;
              if (this.payCloseTime <= this.startTime.getTime()) {
                this.stopTime();
                window.location.reload(); // 时间到了刷新页面
              }
            }, 1000);
          }
        }
      });
    },
    stopTime() {
      clearInterval(this.timeInterval);
      this.timeInterval = null;
    },
    // 获取用户信息
    getinfo() {
      this.orderType = Number(this.$route.query.orderType);
      this.orderId = this.$route.query.orderId;
      // this.userinfo.name = this.user.userCardInfo.name;
      // this.userinfo.position = this.user.userCardInfo.position;
      // this.userinfo.phone = this.user.userCardInfo.phone;
      // this.userinfo.corp = this.user.userCardInfo.corpName;
    },
    // 根据orderType获取URL
    makeurl() {
      console.log(Number(this.orderType));
      switch (Number(this.orderType)) {
        case 3:
        case 10:
        case 16:
          this.cancleBtn = false;
          this.url = '/app/get/park/service/form/order/detail'; // 自定义服务
          break;
        case 4:
          this.url = '/app/get/hr/job/order/detail'; // 找工作
          break;
        case 5:
          this.url = '/app/get/hr/service/order/detail'; // 服务外包
          break;
        case 6:
          this.url = '/app/get/hr/education/order/detail'; // 培训
          break;
        case 7:
          this.url = '/app/get/products/roadshow/order/detail'; // 产品路演
          break;
        case 8:
          this.url = '/app/get/ask/service/order/detail'; // 求购
          break;
        case 9:
          this.cancleBtn = false;
          this.url = '/app/get/food/order/detail'; // 美食街
          break;
        case 11:
          this.url = '/app/get/fine/service/order/detail'; // 优选服务
          break;
        case 12:
          this.cancleBtn = false;
          this.url = '/app/get/meeting/room/order/detail'; // 会议室
          break;
        case 13:
          this.cancleBtn = false;
          this.url = '/app/get/activity/order/detail'; // 活动
          break;
        case 14:
          this.url = '/app/get/welfare/order/detail'; // 福利
          break;
        // case 15:
        //   this.url = ''; // 微社区
        //   break;
        case 17:
          this.url = '/app/get/shop/order/detail'; // 商城
          break;
        case 18:
          this.cancleBtn = false;
          this.url = '/app/get/maintain/order/detail'; // 物业报修
          break;
        case 19:
          this.cancleBtn = false;
          this.url = '/app/get/park/service/form/order/detail'; // 快递
          break;
        default:
          break;
      }
    },
    // 支付
    orderPay() {
      let query = {
        orderId: this.orderId,
        price: this.DetailsInfo.approvalFee>0 ? this.DetailsInfo.approvalFee : this.DetailsInfo.orderFee,
        monthly: this.DetailsInfo.orderServiceInfo ? this.DetailsInfo.orderServiceInfo.monthlyMarker : undefined,
      }
      this.$router.push({path:'/payment', query:query});
    },
    // 取消
    orderCancle() {
      let cancelUrl = '';
      switch (Number(this.orderType)) {
        case 3:// 自定义
        case 10://入驻
        case 16://自定义设施
          cancelUrl = '/app/delete/park/service/form/order';
          break;
        case 9:// 美食街
          cancelUrl = '/app/delete/food/order';
          break;
        case 12:// 会议室
          cancelUrl = '/app/delete/meeting/room/order';
          break;
        case 13:// 活动
          cancelUrl = '/app/cancel/activity/order';
          break;
        case 18:// 物业报修
          cancelUrl = '/app/cancel/maintain/order';
          break;
        case 19://快递
          cancelUrl = '/app/delete/park/service/form/order';
          break;
        default:
          this.$toast('该订单无法取消！');
          return;
      }
      this.$http.post(`${this.URL_PREFIX}${cancelUrl}`, {orderId: this.orderId}, {
        headers: { token: this.token },
      }).then((res) => {
        if(res.data.resCode === '10000') {
          this.$toast('取消成功！');
          this.cancleBtn = true;
          this.getdetails();
        }else{
          this.$toast(res.data.resDesc);
        }
      });
    },
    goEvaluate(refresh){
      refresh = refresh === true ? true : false;
      this.showPopup = !this.showPopup;
      if(refresh){
        this.getdetails();
      }
    },
  },
  computed: {
    ...mapGetters(['currentParkId','token', 'user']),

    time() {
      var endTime = this.payCloseTime;
      var t = endTime - this.startTime.getTime();
      var hour = Math.floor(t / 1000 / 3600);
      var min = Math.floor((t - hour * 3600 * 1000) / 1000 / 60);
      var sec = Math.floor((t - hour * 3600 * 1000 - min * 60 * 1000) / 1000 );
      if (hour < 10) {
      hour = '0' + hour;
      }
      if (min < 10) {
      min = '0' + min;
      }
      if (sec < 10) {
      sec = '0' + sec;
      }
      // const countDownTime = hour + ':' + min + ':' + sec;
      const countDownTime = hour > 0 ? `${hour}时${min}分${sec}秒` : `${min}分${sec}秒`;
      return countDownTime;
    },
  },
  created() {
    if (!this.token) {
      this.$root.eventHub.$emit('login', this.$route.fullPath);
    } else {
      this.getinfo();
      this.makeurl();
      this.getdetails();
    }
  },
  beforeDestroy() {
    this.stopTime();
  },
  components: {
    LinkServiceInfo,
    CustomDemo, FoodDemo, RecomDemo, ProductionDemo, ParkActivityDemo, ExclusiveDemo, JobDemo, ServiceDemo, EduDemo, NeedBuyDemo, OfficeDemo, ProductDetalisDemo, MaintainDemo, OrderEvaluate
  },
}
</script>
<style lang="scss" scoped>
  @import "~@scss";
.headerTitle{
  margin-top: .133333rem;
  font-size: .453333rem;
  font-weight: bold;
  background-color: #fff;
  padding: .36rem .32rem;
}
.orderBox{
    padding: .4rem .32rem;
    width: 100%;
    box-sizing: border-box;
    background-color: #fff;
    border-top: 1px solid rgb(245, 245, 245);
    .orderTitle{
      font-size: .453333rem;
      font-weight: bold;
    }
    .orderPrice{
      margin-top: .266667rem;
      font-size: .4rem;
      font-weight: bold;
      color: rgb(217, 38, 44);
    }
    .orderStatus{
      margin-top: .266667rem;
      font-size: .4rem;
      font-weight: bold;
    }
    .orderDetalis{
      margin-top: .4rem;
      border-top: 1px solid rgb(245, 245, 245);
      padding: .266667rem 0;
      box-sizing: border-box;

      .orderId{
        color: rgb(102, 102, 102);
      }
      .orderTime{
        color: rgb(102, 102, 102);
      }
    }
    .payInfo{
      border-top: 1px solid rgb(245, 245, 245);
      margin-top: .266667rem;
      padding: .266667rem 0;
      box-sizing: border-box;
      p{
        color: rgb(102, 102, 102);
      }
    }
    .processInfo{
      border-bottom: 1px solid rgb(245, 245, 245);
      margin-bottom: .266667rem;
      padding: .266667rem 0;
      box-sizing: border-box;
      .operateStatus{
        width: 13.3%;
        height: 3.6%;
        float: right;
      }
      p{
        color: rgb(102, 102, 102);
      }
    }
  }
.orderDetalis{
  padding: .266667rem .32rem;
  width: 100%;
  box-sizing: border-box;
  background-color: #fff;
  border-top: 1px solid rgb(245, 245, 245);

  .linkService{
    margin-bottom: 20px;

    img{
      width: 100%;
    }
    & > .title{
      font-size: 16px;
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
      margin-top: 5px;

      .price{
        color: #f00;
        text-align: right;
        flex-shrink: 0;
        margin-left: 20px;
      }
    }
    .other{
      line-height: 1;
      font-size: 12px;
      color: #666;
      margin-bottom: 3px;
    }
  }
}
.userInfo{
  width: 100%;
  box-sizing: border-box;
  background-color: #fff;
  border-top: 1px solid rgb(245, 245, 245);
  padding: 0 .32rem;
  p{
    height: 1.173333rem;
    border-bottom: 1px solid rgb(245, 245, 245);
    line-height: 1.173333rem;
    .lable{
      width: 3.173333rem;
      display: inline-block;
      text-align: left;
    }
  }
}
.invoice-row{
  border-bottom: 1px solid rgb(245, 245, 245);
  word-wrap:break-word;
}
.payFoot{
  padding: .133333rem 0;
  text-align: center;
  .btn{
    width: 4.44rem;
  }
}
.payCloseTime{
  padding: .133333rem 0;
  font-size: .333333rem;
  background-color: #fff;
  p{
    text-align: center;
  }
  .time{
    color: rgb(217, 38, 44);
    font-weight: bold;
  }
  .timeText{
    color: rgb(102, 102, 102);
  }
}
.remark{
  margin-top: .32rem;
  padding: .32rem 0;
  .remarkTitle{
    border-bottom: 1px solid rgb(245, 245, 245);
    box-sizing: border-box;
    padding: .32rem 0;
  }
  .remarkText{
    padding: .32rem 0;
    box-sizing: border-box;
  }
}
.user-icon{
  float: left;
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
}
.op-item{
  padding-left: 1.2rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/personal/OrderDetail.vue